export default {
    title: 'Etape 1 : Choisir la famille de produits',
    back_link: {
      route: 'Home',
      text: "Retour à l'accueil"
    },
    button: 'Sélectionner',
};
